<div class="stations-container">
  @if (sacClientContext && sacStructure) {
    <div class="stations-scrollable">
      @for (stationGroup of this.stationGroups; track stationGroup) {
        @if (sacStructure.stationGroup != null && sacStructure.stationGroup.id === stationGroup.id) {
          @for (stationSet of stationGroup.stationSets; track stationSet; let i = $index) {
            <div class="stations-group">
              @if (sacStructure.stationSet == null || stationSet.id === sacStructure.stationSet.id) {
                @if (i > 0) {
                  <sc-content-spacer vertical></sc-content-spacer>
                }
                <sc-sub-title>{{stationSet.name}}</sc-sub-title>
                <sc-content-spacer vertical></sc-content-spacer>
                <div class="stations-list">
                  @for (station of stationSet.stations; track station) {
                    <div>
                      <app-sac-station-item (click)="clickStation(stationSet, station)" [stationSet]="stationSet"
                      [station]="station" [sacClientContext]="sacClientContext" [selected]="station === selection?.station && stationSet === selection?.stationSet"></app-sac-station-item>
                  <div class="bottom-spacer" [ngClass]="{'highlight':
                  selection?.stationSet?.id === stationSet.id
                  && selection?.station?.id===station.id
                  && station.stationUsage.transports?.length !== 0
                  && sacClientContext.showStationUsageDetails===true}"></div>
                    </div>
                    @if (selection?.stationSet?.id === stationSet.id && selection?.station?.id===station.id && station.stationUsage.transports?.length !== 0 && sacClientContext.showStationUsageDetails===true) {
                      <app-sac-station-details class="station-details" [stationSet]="stationSet" [station]="station"
                        [sacClientContext]="sacClientContext" [dashboardContext]="dashboardContext"
                        >
                      </app-sac-station-details>
                    }
                  }
                </div>
              }
            </div>
          }
        }
      }
    </div>
  }
</div>
